import type { App } from 'vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const pinia = createPinia();
const createPluginPinia = (app: App) => {
  pinia.use(({ store }) => {
    store.$reset = () => {
      store.$dispose();
      delete pinia.state.value[store.$id];
    };
  });

  pinia.use(piniaPluginPersistedstate);

  app.use(pinia);
};

export function resetAllStores() {
  const activePinia = getActivePinia();
  if (activePinia) {
    Object.entries(pinia.state.value).forEach(([storeName, state]) => {
      const storeDefinition = defineStore(storeName, state);
      const store = storeDefinition(activePinia);
      store.$reset();
    });
  }
}
export default createPluginPinia;
